import { render, staticRenderFns } from "./VideoListPlugin.vue?vue&type=template&id=3fb96c5d&scoped=true&"
import script from "./VideoListPlugin.vue?vue&type=script&lang=js&"
export * from "./VideoListPlugin.vue?vue&type=script&lang=js&"
import style0 from "./VideoListPlugin.vue?vue&type=style&index=0&id=3fb96c5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb96c5d",
  null
  
)

export default component.exports